"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicRepository = void 0;
var foundation_1 = require("@deqo/foundation");
var TopicTypes_1 = require("./TopicTypes");
var TopicRepository = /** @class */ (function () {
    function TopicRepository() {
        this.store = TopicTypes_1.TopicStore.empty();
    }
    TopicRepository.prototype.has = function (topic) {
        return !!this.store[topic];
    };
    TopicRepository.prototype.get = function (topic) {
        this.guardExists(topic);
        return this.store[topic];
    };
    TopicRepository.prototype.getValue = function (topic, key) {
        return this.get(topic)[key];
    };
    TopicRepository.prototype.add = function (topic) {
        (0, foundation_1.assert)(!this.has(topic), "TopicRepository: topic already exists ".concat(topic, " locally."));
        this.store[topic] = {};
    };
    TopicRepository.prototype.reset = function (topic, values) {
        this.guardExists(topic);
        // Clone and freeze
        var data = Object.assign({}, values);
        return (this.store[topic] = Object.freeze(data));
    };
    TopicRepository.prototype.patch = function (topic, values) {
        var e_1, _a;
        var _b;
        this.guardExists(topic);
        // Copy existing data and always keep frozen
        var data = __assign({}, (this.store[topic] || {}));
        var updates = (_b = Object.entries(values)) !== null && _b !== void 0 ? _b : [];
        try {
            for (var updates_1 = __values(updates), updates_1_1 = updates_1.next(); !updates_1_1.done; updates_1_1 = updates_1.next()) {
                var _c = __read(updates_1_1.value, 2), key = _c[0], val = _c[1];
                if (val === null || val === undefined) {
                    delete data[key];
                }
                else {
                    data[key] = val;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (updates_1_1 && !updates_1_1.done && (_a = updates_1.return)) _a.call(updates_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return (this.store[topic] = Object.freeze(data));
    };
    TopicRepository.prototype.delete = function (topic) {
        var data = this.get(topic);
        delete this.store[topic];
        return data;
    };
    TopicRepository.prototype.guardExists = function (topic) {
        (0, foundation_1.assert)(!!this.has(topic), "TopicRepository: topic ".concat(topic, " does not exist locally."));
    };
    return TopicRepository;
}());
exports.TopicRepository = TopicRepository;
